<template>
    <div class="limiter">
        <div class="container-login100">
			<div class="wrap-login100">
                <div class="sidebar" v-if="!mobile">
                    <h2 class="title"> <img src="/static/Dwerve-favicon.ico" alt=""> Referral Program <i class="fas fa-bars"></i></h2>
                    <div class="list">
                        <h3 class="title">
                            Explore Add-ons  
                        </h3>
                        <p>
                            <ul>
                                <li>Digital soundtrack <span> 5 pts</span><div v-if="(returnCount * 5) < 5" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                <li>Digital art book <span> 5 pts</span><div v-if="(returnCount * 5) < 5"@click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                <li>Digital copy of Dwerve: Classic TD <span> 5 pts</span><div v-if="(returnCount * 5) < 5" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                <li>Extra digital copy of Dwerve <span> 15 pts</span><div v-if="(returnCount * 5) < 15" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                <li>Poster <span> 15 pts</span><div v-if="(returnCount * 5) < 15" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                <li>Shirt <span> 25 pts</span><div v-if="(returnCount * 5) < 25"@click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                <li>Signed printed art book<span> 40 pts</span><div v-if="(returnCount * 5) < 40" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                <li>Signed SNES-style box and manual<span> 40 pts</span><div v-if="(returnCount * 5) < 40" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                <li>Aerie hoodie<span> 60 pts</span><div v-if="(returnCount * 5) < 60" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                            </ul>
                            <div class="upgradeLink" v-if="(returnCount * 5) < 60">
                                <a @click="openModal">Earn more points</a>
                            </div>
                        </p>
                    </div>
             
                    <div @click="helperModal" class="how">How to spend your points?<i  @click="helperModal();swalAddClass();" class="fas fa-info-circle"></i></div>
                </div>

                <div class="main-content">
                 
                    <div class="userInfo">
                        <div class="kickstarterLink" v-if="!mobile" @click="openKickLink()">Go to Kickstarter<i class="fas fa-external-link-alt"></i></div>
                        <h2  v-if="mobile" class="title"> <img src="/static/Dwerve-favicon.ico" alt=""> Referral Program</h2>
                        <h5>{{email}}</h5>
                       
                        <a @click="showDropdown = !showDropdown"><i class="fas fa-cog"></i></a> 
                        <div class="dropdownMenu" v-if="showDropdown">
                            <a @click="openEmailModal(); showDropdown = false;">Change email</a>
                            <a @click="openModal(); showDropdown = false;">Update pledge</a>
                        </div>
                    </div>
                         <div class="sidebar mobileSide" v-if="mobile">
                         <div class="list">
                                <h3 class="title" @click="showMobileList = !showMobileList;show = !show">
                                    Explore Add-ons <i v-if="!show" class="fas fa-chevron-down"></i><i v-if="show" class="fas fa-chevron-up"></i>
                                </h3>
                                <p v-if="showMobileList">
                                    <ul>
                                        <li>Digital soundtrack <span> 5 pts</span><div v-if="(returnCount * 5) < 5" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                        <li>Digital art book <span> 5 pts</span><div v-if="(returnCount * 5) < 5" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                        <li>Digital copy of Dwerve: Classic TD <span> 5 pts</span><div v-if="(returnCount * 5) < 5" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                        <li>Extra digital copy of Dwerve <span> 15 pts</span><div v-if="(returnCount * 5) < 15" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                        <li>Poster <span> 15 pts</span><div v-if="(returnCount * 5) < 15" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                        <li>Shirt <span> 25 pts</span><div v-if="(returnCount * 5) < 25" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                        <li>Signed printed art book<span> 40 pts</span><div v-if="(returnCount * 5) < 40" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                        <li>Signed SNES-style box and manual<span> 40 pts</span><div v-if="(returnCount * 5) < 40" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                        <li>Aerie hoodie<span> 60 pts</span><div v-if="(returnCount * 5) < 60" @click="openModal" class="ex ref-tooltip">!<span class="tooltiptext">Not enough points</span></div></li>
                                    </ul>
                                </p>
                         </div>
                    </div>
                    <div class="refer-header-wrapper">
                        <div class="refer-head">
                           
                            <h2>Refer up to 5 Friends & Earn Add-ons <i  @click="helperModal();swalAddClass();" class="fas fa-info-circle"></i></h2>
                            <p>For each friend that pledges $15 or more, get referral points to spend on add-ons.</p>
                        </div>

                        <h4>Share link with your friends</h4>
                        <div class="control" @click="onCopy" >
                             <input type="text" disabled v-model="shareLink">
                            <a href="#" @click="onCopy" class="button is-info" id="refLink"><i class="fa fa-link" aria-hidden="true"></i>Copy Link</a>
                        </div>
                        <div class="button-group" v-if="!mobile">
                            <h5>Share now</h5>
                            <a :href="facebookLink" target="_blank" class="facebook-blue"><i class="fab fa-facebook-f"></i>Facebook</a>
                            <a :href="twitterLink" target="_blank" class="twitter-blue"><i class="fab fa-twitter"></i>Twitter</a>
                            <a :href="linkedinLink" target="_blank" class="linkedin-blue"><i class="fab fa-linkedin-in"></i>LinkedIn</a>
                        </div>
                         <div class="button-group" v-if="mobile">
                            <h5>Share now</h5>
                            <a :href="fbLink" target="_blank" class="facebook-blue"><i class="fab fa-facebook-f"></i></a>
                            <a :href="twLink" target="_blank" class="twitter-blue"><i class="fab fa-twitter"></i></a>
                            <a :href="lkLink" target="_blank" class="linkedin-blue"><i class="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>

                     <div class="refer-header-wrapper reward">
                        
                         <div class="reward-info"> <div class="badge"><span>{{referralCount * returnCount}}<span class="totalCount"><span class="excl">/</span>{{returnCount * 5}}</span></span> <span>Points</span></div>
                             <div class="coin">
                                  <img src="/static/assets/images/coin.svg" alt="">
                             </div>
                            <div class="rInfo">
                                 <h2 class="current">Current Backer Tier: <span @click="openModal"> {{pledgeTier}}</span></h2>
                                <h5>You get {{returnCount}} points for each friend that pledges $15 or more </h5>
                            </div>
                         </div>
                    </div>
                    <progressBar />
                   
                </div>
			</div>
		</div>
        <EditModal v-show="isModalVisible"/>
         <NewEmailModal v-show="isEmailModalVisible"/>
    </div>
</template>

<script>
import NewEmailModal from "./NewEmailModal.vue";
import Router from '../../router';
import EditModal from "./EditModal.vue";
import { mapActions } from 'vuex';
import progressBar from "@/components/progressBar.vue";
export default {
    data: function() {
    return {
        show: false,
        isModalVisible: false,
        isEmailModalVisible: false,
        fbLink: "",
        twLink: "",
        lkLink: "",
        emLink: "",
        mobile: false,
        showMobileList: false,
        showDropdown: false
    };
  },
  computed: {
    email () {
      return this.$store.state.referrals.user.email
    },
    pledgeTier () {
      return this.$store.state.referrals.user.pledgeTier
    },
    shareLink () {
      return this.$store.state.referrals.user.shortUrl
    },
     referralCount () {
      return this.$store.state.referrals.user.referralCount
    },
    returnCount() {
        return this.$store.getters.getCount
    },
    facebookLink(){
        return "https://www.facebook.com/sharer.php?u=" + this.$store.state.referrals.user.shortUrl;
    },
    twitterLink(){
        return "https://twitter.com/intent/tweet?url=" + this.$store.state.referrals.user.shortUrl;
    },
    linkedinLink(){
        return "https://www.linkedin.com/shareArticle?mini=true&url=" + this.$store.state.referrals.user.shortUrl;
    }
  },
  methods: {
    ...mapActions(['openEditModal','fetchUser','setCount','countCheck','pointModal','helperModal']),
    onCopy() {
        this.$clipboard(this.shareLink);
        document.querySelector("#refLink").innerHTML = "<i aria-hidden='true' class='fa fa-link'></i> Copied!"
    },
    openModal(){
         this.isModalVisible = true;
         document.querySelector('.modal-backdrop').style.display = "flex";
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getCookie(name){
        var cookieArr = document.cookie.split(";");
        for(var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            if(name == cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    },
    shareLinks(){
        this.fbLink = `https://www.facebook.com/sharer.php?u=${this.shareLink}`;
        this.twLink = `https://twitter.com/intent/tweet?url=${this.shareLink}`;
        this.lkLink = `https://www.linkedin.com/shareArticle?mini=true&url=${this.shareLink}`;
    },
    isMobile() {
        if(window.innerWidth < 1315) {
            this.mobile = true;
         return true
        } else {
            this.mobile = false;
          return false
        }
     },
    openEmailModal(){
         this.isEmailModalVisible = true;
         document.querySelector('.modal-backdrop2').style.display = "flex";
    },
    swalAddClass(){
        setTimeout(function(){document.querySelector(".swal2-popup").classList.add('swalHow');});
    },
    openKickLink(){
        window.open("https://www.kickstarter.com/projects/halfhumangames/dwerve-tower-defense-dungeon-crawler-rpg", "_blank"); 
    }
  },
  components: {
      progressBar,
      EditModal,
      NewEmailModal
  },
   created() {
        var cookieID = this.getCookie("refProgramId");
        this.fetchUser(cookieID).then(() => this.setCount(this.referralCount));
  },
  mounted(){
    
    var cookieID = this.getCookie("refProgramId");
    if(cookieID != null){
           Router.push({ name: 'ReferralDashboard', params: { id: cookieID} })
    }else if (cookieID == null){
        Router.push({ name: 'Referral' })
    }
    var self = this;

     this.$nextTick(function() {
      window.addEventListener("resize", this.isMobile);
    });
    this.isMobile();
  }
}
</script>


<style scoped>
i.fas.fa-external-link-alt {
    font-size: 15px;
    margin-left: 6px;
}
.kickstarterLink {
    width: 100%;
    padding-left: 25px;
    color: #45aaeb;
    font-size: 20px;
    font-family: 'Titillium Web', sans-serif;
    cursor: pointer;
}
.kickstarterLink {
    width: 100%;
    padding-left: 25px;
}
.dropdownMenu {
    position: absolute;
    top: 48px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    z-index: 9;
    border-radius: 3px;
    background: #123d6f;
}
.userInfo .dropdownMenu a {
    background: #123d6f;
    border-bottom: 1px solid #123e6f;
    box-shadow: none;
    display: block;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    width: 145px;
    padding: 0;
    font-family: 'Titillium Web', sans-serif;
}
h2.current span:hover {
    text-decoration: underline;
}
h2.current span {
    cursor: pointer;
}
.how i.fas.fa-info-circle {
    font-size: 19px;
    position: relative;
    top: 5px;
    margin-left: 10px;
}
.refer-head h2 i.fas.fa-info-circle {
    position: absolute;
    top: 13px;
    right: 11px;
}
.refer-header-wrapper.reward {
    height: 152px;
    margin-top: 37px;
    align-items: flex-start;
    background: linear-gradient(to right, #10264c, #123e71);
    min-height: 160px;
}

.reward-info {
    display: flex;
    justify-content: center;
    height: 100%;
    width: 77%;
    position: relative;
}

.rInfo {
    flex-grow: 1;
    align-self: center;
    text-align: center;
    max-width: 518px;
}
.rInfo h5 {
    font-family: 'Titillium Web', sans-serif;
    font-size: 20px;
    color: #fff;
}
.coin img {
    width: 42%;
    height: auto;
}

.coin {
    width: 201px;
    display: flex;
    justify-content: center;
}
h2.current {
    font-family: 'Titillium Web', sans-serif;
    font-size: 27px;
    color: #fff;
    margin-top: 0;
    text-shadow: 1px 1px 2px #11274d;
}
.refer-head h2.current {
    margin-bottom: 0;
    margin-top: 0;
    font-size: 31px;
    text-shadow: 1px 1px 2px #1f55cc;
}
i.fas.fa-info-circle {
    color: #fff;
    font-size: 20px;
    display: flex;
    justify-content: end;
    cursor: pointer;
}
.ref-tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.ref-tooltip .tooltiptext {
    visibility: hidden;
    background: none;
    background: #ca3030 linear-gradient(180deg, #ca3030, #ca3030) repeat-x;
    width: 132px;
    font-family: 'Titillium Web', sans-serif;
    color: #fff;
    text-align: center;
    padding: 0px 0;
    border-radius: 5px;
    position: absolute;
    z-index: 1;
    bottom: -4px;
    left: 50%;
        font-size: 12px;
    margin-left: 21px;
    box-shadow: none;
    opacity: 0;
    transition: opacity 0.3s;
}

/* Tooltip arrow */
.ref-tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 32%;
    left: -5px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #5550 #ca3030 transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.ref-tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}
span.excl {
    display: inline !important;
    font-size: 42px !important;
    font-family: 'Titillium Web', sans-serif;
    font-weight: 100 !important;
    margin-left: 4px;
}
span.totalCount {
    display: inline !important;
}
.ex {
    display: inline;
    font-size: 18px;
    font-family: Digitalt;
    margin-left: 10px;
    padding: 0px 7px;
    border-radius: 62px;
    border: 2px solid #f8b21a;
    cursor: pointer;
    color: #ffa820;
}
.badge span:first-child {
    font-size: 50px;
    line-height: .7;
}
.list ul span {
    font-family: Digitalt;
    font-weight: 100;
    background: #49a9f0 linear-gradient(180deg, #6ec0e6, #25aff4) repeat-x;
    font-size: 17px;
    padding: 3px 7px;
    border-radius: 11px;
    text-shadow: 1px 1px 2px #1a3b84;
    margin-left: 10px;
    box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 20%);
}
.refer-header-wrapper {
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    height: 355px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    max-width: 1220px;
    width: 100%;
}
.refer-head {
    background: linear-gradient(-135deg, #5aaaff, #3ea9e4);
    border-radius: 10px 10px 0px 0px;
    padding: 30px;
    position: relative;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
}
.refer-head h2 {
    font-size: 34px;
    font-family: Digitalt;
    color: #fff;
    margin-top: 0;
    font-weight: 100;
    text-shadow: 1px 1px 2px #1a3b84;
}
.refer-head p {
    font-size: 16px;
    font-family: 'Titillium Web', sans-serif;
    color: #fff;
}
.badge span {
    display: block;
}
.button-group a {
    padding: 7px 20px;
    color: #fff;
    border-radius: 25px;
    font-size: 16px;
    margin-left: 15px;
}
a.facebook-blue {
    background: #345d9f;
}
a.twitter-blue {
    background: #25aff4;
}
a.linkedin-blue {
    background: #007cba;
}
a.email-blue {
    background: #6ec0e6;
}
.button-group i {
    font-size: 20px;
    padding-right: 10px;
}
.button-group a:hover {
    text-decoration: none;
}
.button-group h5 {
    font-size: 20px;
    color: #999;
    font-family: Digitalt;
}
.badge {
    position: absolute;
    top: 0;
    right: -168px;
    font-family: Digitalt;
    height: 119px;
    background: #dd6800 linear-gradient(180deg, #efc40e, #ffa720) repeat-x;
    width: 154px;
    padding-top: 25px;
    box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 25%);
    border-radius: 0px 0px 10px 10px;
    font-size: 32px;
    text-align: center;
    text-shadow: 1px 1px 2px #1a3b84;
    line-height: 36px;
}
.sidebar {
    display: flex;
    flex-direction: column;
    width: 400px;
    background: linear-gradient(to right, #10264c, #123e71);
    padding: 0px 0px;
    height: 100vh;
    box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);
    min-width: 250px;
}
.refer-header-wrapper h4 {
    color: #4a4a4a;
    padding: 14px 20px;
    font-family: 'Titillium Web', sans-serif;
    font-size: 20px;
}
.limiter {
    width: 100%;
    margin: 0 auto;
}
.login100-pic {
   width: 100%;
    max-width: 600px;
}
.container-login100 {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    background: #9053c7;
    background: linear-gradient(-135deg, #2a5384, #4297c6);
}
.wrap-login100 {
    width: 100%;
    background: #fff;
    align-content: center;
    overflow: hidden;
    align-content: start;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.login100-pic img {
    max-width: 100%;
}
.login100-form {
    width: 290px;
}
.login100-form-title {
    font-family: Digitalt;
    font-size: 36px;
    color: #333333;
    line-height: 1.2;
    text-align: center;
    width: 100%;
    display: block;
    padding-bottom: 54px;
}
.input100 {
    font-family: Digitalt;
    font-size: 15px;
    border: none;
    line-height: 1.5;
    color: #666666;
    display: block;
    width: 100%;
    background: #e6e6e6;
    height: 50px;
    border-radius: 25px;
    padding: 0 30px 0 68px;
}
.focus-input100 {
    display: block;
    position: absolute;
    border-radius: 25px;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 0px 0px;
    color: rgba(87,184,70, 0.8);
}
.symbol-input100 {
    font-size: 15px;
    display: flex;
    align-items: center;
    position: absolute;
    border-radius: 25px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-left: 35px;
    pointer-events: none;
    color: #666666;
    transition: all 0.4s;
}
.validate-input {
    position: relative;
}
.wrap-input100 {
    position: relative;
    width: 100%;
    z-index: 1;
    margin-bottom: 10px;
}
.login100-form-btn {
    font-family: Digitalt;
    font-size: 15px;
    border: none;
    line-height: 1.5;
    color: #fff;
    text-transform: uppercase;
    width: 100%;
    height: 50px;
    border-radius: 25px;
    background: #57b846;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 25px;
    transition: all 0.4s;
}
ul.steps {
    display: flex;
    position: absolute;
    list-style-type: none;
    margin: 0;
    padding: 0;
    background-color: #fff;
    text-align: center;
}
.steps li {
    display: inline-block;
    margin: 20px;
    color: #ccc;
    padding-bottom: 5px;
}
.steps li.is-active {
    border-bottom: 1px solid #3498db;
    color: #3498db;
}
select#tiers {
    font-family: Digitalt;
    font-size: 15px;
    border: none;
    line-height: 1.5;
    color: #666666;
    display: block;
    width: 100%;
    background: #e6e6e6;
    height: 50px;
    border-radius: 25px;
   padding: 0 30px 0 20px;
}
select::-ms-expand {
    display: none;
}
.ui-select{width: 100%}
/* This is to remove the arrow of select element in IE */
select::-ms-expand {	display: none; }
select{
    -webkit-appearance: none;
    appearance: none;
}
@-moz-document url-prefix(){
	.ui-select{border: 1px solid #CCC; border-radius: 4px; box-sizing: border-box; position: relative; overflow: hidden;}
  .ui-select select { width: 110%; background-position: right 30px center !important; border: none !important;}
}

.main-content{
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    padding: 42px;
    padding-top: 85px;
    overflow-y: scroll;
    background: #f1f4f6;
    align-items: center;
}
.control {
    display: flex;
    width: 100%;
    padding: 0px 20px;
}
a#refLink {
       flex-grow: 1;
    background: #4ea9f4 linear-gradient(180deg, #4da9f2, #52aaf8) repeat-x;
    border-radius: 0px 10px 10px 0px;
    line-height: 50px;
    font-family: Digitalt;
    color: #fff;
    position: relative;
    width: 150px;
    left: -26px;
    text-shadow: 1px 1px 2px #6478a5;
    font-size: 20px;
    padding: 0px 15px 0px 15px;
    margin-top: 0;
}
.control input {
    width: 90%;
}
.control input {
    cursor: pointer;
    width: 90%;
    font-size: 16px;
    border: 2px solid #50a9f6;
    border-radius: 25px;
    height: 50px;
    padding: 0px 19px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
}
a#refLink:hover {
    text-decoration: none;
}
.control input:focus {
    border-color: #66afe9;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
a#refLink i.fa.fa-link {
    padding-right: 7px;
}
.button-group {
    display: flex;
    padding: 20px;
}

.userInfo {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    align-items: center;
    width: 100%;
    left: 0;
    height: 60px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    background: linear-gradient(-135deg, #fff, #ffffff);
    padding-right: 45px;
}
.userInfo h5 {
    font-weight: 400;
    font-size: 14px;
    color: #8c8787;
    text-transform: uppercase;
    line-height: 18px;
    padding-right: 18px;
    font-family: 'Titillium Web', sans-serif;
}
.userInfo a {
    font-size: 20px;
    cursor: pointer;
    min-width: 30px;
    height: 30px;
    border-radius: 3px;
    text-align: center;
    background: #52a9f5;
    width: 30px;
    box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
}
h2.title {
    padding: 1px 17px;
    background: linear-gradient(to right, #10264c, #123e71);
    margin: 0;
    font-size: 24px;
    color: #fff;
    font-family: 'Titillium Web', sans-serif;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 10px;
}
h2.title img {
    width: 58px;
}
.userInfo span {
    display: block;
    font-size: 12px;
}
i.fas.fa-cog {
    color: #fff;
    font-size: 14px;
    position: relative;
    bottom: 3px;
}
i.far.fa-user {
    font-size: 20px;
    margin-right: 10px;
    color: #fff;
    background: #ececec;
    padding: 10px;
    border-radius: 63px;
}
.how {
    color: #fff;
    cursor: pointer;
    min-height: 5px;
    max-width: 400px;
    padding: 0px 26px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    position: absolute;
    font-size: 17px;
    border-radius: 15px;
    box-sizing: border-box;
    transition: all .3s;
    font-family: 'Titillium Web', sans-serif;
    bottom: 20px;
}
.list {
    color: #fff;
    font-family: 'Titillium Web', sans-serif;
    padding: 0px 20px;
}
.how p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    cursor: pointer;
}
h3.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    cursor: pointer;
    font-size: 18px;
    cursor: pointer;
    font-family: 'Titillium Web', sans-serif;
    font-weight: 600;
}
i.fas.fa-chevron-down, i.fas.fa-chevron-up {
    color: rgb(255 255 255 / 31%);
    font-size: 18px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
a.button.kickstarter {
    position: absolute;
    bottom: 0;
    width: 325px;
    left: 41px;
    height: 55px;
    color: #fff;
    background: linear-gradient(-135deg, #1fd28d, #05ce78);
    margin-bottom: 25px;
    border-radius: 32px;
    text-align: center;
    cursor: pointer;
    box-shadow: 7px 3px 15px 0 rgb(0 0 0 / 45%);
    transition: all 0.1s ease-in-out;
}
a.button.kickstarter span {
    font-size: 22px;
    font-family: Digitalt;
    line-height: 53px;
    text-shadow: 1px 1px 2px #1a3b84;
}
a.button.kickstarter:hover {
    text-decoration: none;
     box-shadow: 7px 2px 28px 0 rgb(0 0 0 / 65%);
}
i.fas.fa-arrow-right {
    font-size: 18px;
    padding-left: 6px;
}
.list ul {
    font-size: 16px;
    line-height: 28px;
    list-style: none;
    padding-left: 0px;
}
.sidebar.mobileSide {
    height: auto;
    padding-bottom: 11px;
    position: relative;
    left: 0px;
    width: 100vw;
    display: block;
}
@media only screen and (max-width: 1315px) {
    h2.title {
        width: 100%;
        box-shadow: none;
        background: #fff;
    }
    .main-content {
        padding-bottom: 0 !important;
        height: 100vh;
        padding: 61px 8px;
    }
    .refer-header-wrapper {
        margin-top: 35px;
        height: auto;
        min-height: 400px;
    }
    .refer-head h2 {
        font-size: 24px;
        max-width: 250px;
        margin-top: 0;
    }
    .badge span:first-child {
        font-size: 40px;
    }
    .badge {
        height: 90px;
        width: 116px;
        padding-top: 10px;
        right: -137px;
    }
    a#refLink {    
        width: 200px;
        left: -24px;
        font-size: 16px;
    }
    .button-group a {
        padding: 11px 12px !important;
        display: flex;
        width: 42px;
        height: 40px;
    }
    .list {
        padding-right: 0;
    }
    h3.title {
        justify-content: end;
    }
    h3.title i.fas {
        margin-left: 10px;
    }
    .userInfo {
        padding-right: 10px;
    }
}
@media screen and (max-width: 1315px) and (min-width: 700px)  {
    .main-content {
        padding-bottom: 0 !important;
        height: 100vh;
        padding: 61px 42px;
    }
    .sidebar.mobileSide {
        left: 0px;
    }
    .refer-head h2 {
        font-size: 34px;
        max-width: 400px;
        margin-top: 15px;
    }
}
@media only screen and (max-width: 605px) {
    h2.title {
       font-size: 0px;
        box-shadow: none;
        width: 100%;
        padding-top: 3px;
    }
    i.far.fa-user {
        display: none;
    }
    .refer-head h2 {
        max-width: 238px;
    }
    .reward-info {
        width: 100%;
    }
    h2.current {
        max-width: 195px;
        margin-bottom: 9px;
        font-size: 20px;
        margin-left: 15px;
    }
    .rInfo h5 {
        max-width: 205px;
        font-size: 16px;
        margin-left: 13px;
    }
    .coin {
        display: none;
    }
    .badge {
        right: 10px;
    }
}

h2.title i.fas.fa-bars {
    width: 32%;
    text-align: end;
    visibility: hidden;
}
.upgradeLink {
    width: 100%;
    text-align: center;
    margin-top: 30px;
    position: relative;
}
.upgradeLink a {
    color: #ffffff;
    font-size: 23px;
    text-transform: capitalize;
    border-radius: 33px;
    padding: 3px 17px;
    text-shadow: 1px 1px 1px #6d6d6d;
    cursor: pointer;
    background: linear-gradient(-135deg, #1fd28d, #05ce78);
    width: 100%;
    display: block;
    font-family: Digitalt;
}
.upgradeLink a:hover {
    text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/views/Referral/ReferralDashboard.vue